import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class OSearchService {
  public searchResult: { route: string; entity: Object }[];

  constructor() {}
}
